module.exports = __webpack_public_path__ + "static/img/mbgzzs_mzjg_Icon.png";